module.exports = __webpack_public_path__ + "static/media/car9.d4efc378.jpg";